import { type RouteObject } from 'react-router'
import type { Observable } from 'rxjs'
import type { Id } from '@/infra/id'
import type { SnackbarErrorHandlerFactory } from '@/features/shell'
import type { BookkeepingPlatformConnectionStore } from '@/features/bookkeeping/platform-connections/BookkeepingPlatformConnectionStore'
import { createXeroOAuth2Loader } from '@/features/bookkeeping/xero-route-loader'
import { createQuickBooksOAuth2Loader } from '@/features/bookkeeping/quickbooks-route-loader'

export interface CreateBookkeepingRoutesOptions {
  bookkeepingPlatformConnectionStore: PromiseLike<BookkeepingPlatformConnectionStore>
  createSnackbarErrorHandler: SnackbarErrorHandlerFactory
  currentWorkspaceId$: Observable<Id | null>
}

/**
 * Creates routes for bookkeeping feature.
 */
export function createRoutes(
  options: CreateBookkeepingRoutesOptions,
): RouteObject[] {
  return [
    {
      path: 'bookkeeping',
      children: [
        {
          path: 'auth',
          children: [
            {
              path: 'quickbooks',
              loader: createQuickBooksOAuth2Loader(options),
              element: null,
            },
            {
              path: 'xero',
              loader: createXeroOAuth2Loader(options),
              element: null,
            },
          ],
        },
      ],
    },
  ]
}
